import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    IParams,
    RedirectParams,
} from '../../../../shared/types/redirectParams';
import { ProcedureParamsHistorical } from '../../../../shared/types/systemConfiguration/procedureParams';

import { FormikProps } from 'formik';
import { PROCEDURE, PROCEDURE_DETAIL } from '../../../../routes/paths';
import {
    asyncGetParam,
    asyncPatchtProcedureParam,
    asyncPostParam,
    asyncGetProcedureParamHistorical,
} from '../../../../services/param.service';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';

export const useProcedurePqrForm = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idProcedure } = useParams();
    const [procedure, setProcedure] = useState<IParams>();
    const [loading, setLoading] = useState(false);
    const [formikProcedureData, setformikProcedureData] =
        useState<FormikProps<RedirectParams>>();

    const [procedureHistorical, setProcedureHistorical] =
        useState<ProcedureParamsHistorical[]>();
    const isValidForm = formikProcedureData?.isValid;

    const handleCleanAndBack = () => {
        formikProcedureData?.resetForm();
        navigate(PROCEDURE);
    };

    const handleSubmit = async () => {
        await formikProcedureData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: RedirectParams =
            formikProcedureData?.values as RedirectParams;

        let res: any | undefined = undefined;

        try {
            if (procedure && procedure.id)
                res = await asyncPatchtProcedureParam(procedure.id, data);
            else res = await asyncPostParam(data);
        } catch (error) {}

        if (res?.items) {
            ToastSwal.fire({
                text: `¡Felicidades! El trámite se ${
                    procedure && procedure.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${PROCEDURE_DETAIL}/${res?.items?.id}`);
        } else {
            const message = `Lo sentimos, no se pudo 
                ${procedure && procedure.id ? 'actualizar' : 'crear'}
                el trámite. Por favor, asegúrate de ${
    res?.message !== 'PARAM-FAIL-DUPLICATED'
        ? 'diligenciar los datos correctamente'
        : 'que no exista previamente'
} e intenta nuevamente más tarde.`;

            ToastSwal.fire({
                text: message,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idProcedure?.trim())) {
            setLoading(true);
            asyncGetParam(idProcedure?.trim())
                .then((procedure: any) => {
                    if (!procedure || !procedure.items) navigate(PROCEDURE);
                    setProcedure(procedure?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idProcedure]);

    useEffect(() => {
        if (Boolean(idProcedure?.trim()) && showHistorical) {
            setLoading(true);

            asyncGetProcedureParamHistorical(idProcedure?.trim())
                .then((resp) => {
                    if (resp) setProcedureHistorical(resp);
                    else navigate(PROCEDURE);
                })
                .finally(() => setLoading(false));
        }
    }, [idProcedure, showHistorical]);

    return {
        procedure,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setformikProcedureData,
        procedureHistorical,
    };
};
